import { render, staticRenderFns } from "./StudentGradeForm.vue?vue&type=template&id=50e4640c&scoped=true"
import script from "./StudentGradeForm.vue?vue&type=script&lang=js"
export * from "./StudentGradeForm.vue?vue&type=script&lang=js"
import style0 from "./StudentGradeForm.vue?vue&type=style&index=0&id=50e4640c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4640c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e4640c')) {
      api.createRecord('50e4640c', component.options)
    } else {
      api.reload('50e4640c', component.options)
    }
    module.hot.accept("./StudentGradeForm.vue?vue&type=template&id=50e4640c&scoped=true", function () {
      api.rerender('50e4640c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentGrade/modules/StudentGradeForm.vue"
export default component.exports